import { Dispatch, SetStateAction } from 'react';

import { IOffersFragment } from 'generated/graphql-gateway';
import { IAppliedOffer } from 'generated/rbi-graphql';
import { IncentiveEvaluationMap } from 'state/loyalty/hooks/types';
import { ICart } from 'state/loyalty/in-restaurant-redemption';
import { LoyaltyOffer } from 'state/loyalty/types';

export type ReduceOffers = ({
  cmsOffers,
  baseOffers,
  appliedOffers,
  inRestaurantRedemptionCart,
  checkLoyaltyOfferAvailability,
  enableSortOffersForServiceMode,
  setOffersFeedbackMap,
}: {
  cmsOffers: LoyaltyOffer[];
  personalizedOffers: LoyaltyOffer[];
  baseOffers: IOffersFragment[];
  appliedOffers: IAppliedOffer[];
  inRestaurantRedemptionCart: ICart;
  checkLoyaltyOfferAvailability: (offer: LoyaltyOffer) => boolean;
  enableSortOffersForServiceMode: boolean;
  setOffersFeedbackMap: Dispatch<SetStateAction<IncentiveEvaluationMap | null>>;
}) => LoyaltyOffer[][];

export enum OffersServiceMode {
  PICKUP_ONLY = 'pickUpOnly',
  DELIVERY_ONLY = 'deliveryOnly',
}

export enum AvailableTabs {
  AllOffers,
  Favorites,
}
